export default __webpack_public_path__ + "static/media/2016.7d40111c.png";